/**
 * The current version of the message protocol. This is incremented when there are significant
 * changes to the flow of messages in a session, or breaking changes to individual message
 * schemas occur, but typically not when individual message schemas are updated in backward and
 * forward compatible ways.
 */
export const currentProtocolVersion = 2;
//# sourceMappingURL=messages.js.map